import { DATE_PICKER_FORMAT } from 'Constants/index'
import {
  DatePicker,
  Flex,
  Group,
  InputText,
  Item,
  SearchForm,
  Select,
  Text,
  TEXT_VARIANT_BOLD
} from 'mailup-web-components'
import { useRef } from 'react'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'
import {
  useRecoilCallback,
  useRecoilState,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState
} from 'recoil'
import { searchCallback } from '../recoil/callbacks/callbacks'
import { pageState, searchState } from '../recoil/state/page'

const Search = () => {
  const intl = useIntl()
  const { expandedAdvacedSerach } = useRecoilValue(pageState)
  const setPageState = useSetRecoilState(pageState)
  const [
    { searchBy, searchText, searchDateBy, searchDateFrom, searchDateTo },
    setSearch
  ] = useRecoilState(searchState)
  const { current: currentDate } = useRef(new Date())
  const resetSearchState = useResetRecoilState(searchState)

  const search = useRecoilCallback(searchCallback, [])
  const { idSource } = useParams()

  const searchFields = [
    {
      value: 'Title',
      label: intl.formatMessage({
        id: 'Load.ContentsSourcesViewContents.Title'
      })
    },
    {
      value: 'ContentKey',
      label: intl.formatMessage({
        id: 'Load.ContentsSourcesViewContents.ContentKey'
      })
    },
    {
      value: 'SubTitle',
      label: intl.formatMessage({
        id: 'Load.ContentsSourcesViewContents.SubTitle'
      })
    },
    {
      value: 'Summary',
      label: intl.formatMessage({
        id: 'Load.ContentsSourcesViewContents.Summary'
      })
    },
    {
      value: 'LinkText',
      label: intl.formatMessage({
        id: 'Load.ContentsSourcesViewContents.LinkText'
      })
    },
    {
      value: 'LinkURL',
      label: intl.formatMessage({
        id: 'Load.ContentsSourcesViewContents.LinkURL'
      })
    },
    {
      value: 'Author',
      label: intl.formatMessage({
        id: 'Load.ContentsSourcesViewContents.Author'
      })
    },
    {
      value: 'Category',
      label: intl.formatMessage({
        id: 'Load.ContentsSourcesViewContents.Category'
      })
    }
  ]

  const searchDateFields = [
    {
      value: 'ContentDate',
      label: intl.formatMessage({
        id: 'Load.ContentsSourcesViewContents.ContentDate'
      })
    },
    {
      value: 'ContentLoadingDate',
      label: intl.formatMessage({
        id: 'Load.ContentsSourcesViewContents.ContentLoadingDate'
      })
    }
  ]

  const setExpandedAdvacedSerach = () => {
    setPageState((prev) => ({
      ...prev,
      expandedAdvacedSerach: !prev.expandedAdvacedSerach
    }))
  }

  const onChangesearchText = (e) => {
    setSearch((prev) => ({
      ...prev,
      searchText: e.target.value
    }))
  }

  const onChangesearchBy = (val) => {
    setSearch((prev) => ({
      ...prev,
      searchBy: val
    }))
  }

  const onChangesearchDateBy = (val) => {
    setSearch((prev) => ({
      ...prev,
      searchDateBy: val
    }))
  }

  const handleChangeDateFrom = (val) => {
    setSearch((prev) => ({
      ...prev,
      searchDateFrom: val
    }))
  }

  const handleChangeDateTo = (val) => {
    setSearch((prev) => ({
      ...prev,
      searchDateTo: val
    }))
  }

  const resetSearch = () => {
    resetSearchState()
    setPageState((prev) => ({
      ...prev,
      expandedAdvacedSerach: false
    }))
    search(idSource, false)
  }

  const onClickSearch = () => {
    setSearch((prev) => ({
      ...prev,
      pageNumber: 1
    }))
    search(idSource, false)
  }

  const AdvancedSearchComponent = () => (
    <>
      <Group>
        <Item of={2}>
          <Select
            searchable={false}
            options={searchDateFields}
            value={searchDateBy}
            onChange={onChangesearchDateBy}
          />
        </Item>

        <Flex alignItems='center' justifyContent='flex-end' columnGap='8px'>
          <Text variant={TEXT_VARIANT_BOLD}>
            {intl.formatMessage({
              id: 'Load.MailupCommon.FromDate'
            })}
          </Text>

          <DatePicker
            value={searchDateFrom}
            callback={handleChangeDateFrom}
            isClearable={false}
            locale={intl.locale}
            dateFormat={DATE_PICKER_FORMAT}
            showTimeSelect
            maxDate={searchDateTo || currentDate}
            data-mu-test='searchDateFrom-from'
          />
        </Flex>
      </Group>
      <Group>
        <Item>
          <Flex alignItems='center' justifyContent='flex-start' columnGap='8px'>
            <Text variant={TEXT_VARIANT_BOLD}>
              {intl.formatMessage({
                id: 'Load.MailupCommon.ToDate'
              })}
            </Text>

            <DatePicker
              name='filterByFieldTo'
              value={searchDateTo}
              callback={handleChangeDateTo}
              isClearable={false}
              locale={intl.locale}
              dateFormat={DATE_PICKER_FORMAT}
              showTimeSelect
              minDate={searchDateFrom || null}
              maxDate={currentDate}
              data-mu-test='searchDateFrom-to'
            />
          </Flex>
        </Item>
      </Group>
    </>
  )

  return (
    <SearchForm
      labelBtnSearch={intl.formatMessage({
        id: 'Load.MailupCommon.Search'
      })}
      labelBtnReset={intl.formatMessage({
        id: 'Load.MailupCommon.Reset'
      })}
      advanced
      expanded={expandedAdvacedSerach}
      onClickToggle={setExpandedAdvacedSerach}
      AdvancedSearchComponent={AdvancedSearchComponent}
      onClickReset={resetSearch}
      onSubmit={onClickSearch}
    >
      <Group>
        <Item>
          <InputText
            placeholder={intl.formatMessage(
              {
                id: 'Load.ContentsSourcesViewContents.SearchInFieldPlaceholder'
              },
              {
                field: searchBy
              }
            )}
            value={searchText}
            onChange={onChangesearchText}
          />
        </Item>
      </Group>
      <Group>
        <Item>
          <Select
            searchable={false}
            options={searchFields}
            value={searchBy}
            onChange={onChangesearchBy}
          />
        </Item>
      </Group>
    </SearchForm>
  )
}

export default Search
